import { fetchCategories } from "src/services/EngagementAPIs";
import type { ApiLang } from "src/utils/apiLang";
import type { AudienceListOption } from "src/utils/audienceListLabels";
import { UNSUBSCRIBED_LIST_KEYWORD } from "./CampaignSetupConstants";

export const getUnsubscribedLists = (options: AudienceListOption[]): string[] =>
  options
    .map(option => option.name)
    .filter(name => name.toLowerCase().includes(UNSUBSCRIBED_LIST_KEYWORD));

export const isSitemapAvailable = async (lang: ApiLang): Promise<boolean> => {
  try {
    const response = await fetchCategories(lang);
    const websiteCategories =
      response?.website_categories || response?.website_urls || response?.categories;
    return Boolean(websiteCategories?.length);
  } catch {
    return false;
  }
};
